import { create } from 'zustand';

import { createDetectTextResultSlice, type DetectTextResultSlice } from './slices/createDetectTextResultSlice';

export type DetectTextResultState = DetectTextResultSlice;

export const useDetectTextResultStore = create<DetectTextResultState>()((...args) => ({
  ...createDetectTextResultSlice()(...args),
}));
